import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class SettingsProvider {
  static apiUrl: string = environment.apiUrl;

  static versionApp: string = environment.versionApp; //* Versión ID APP

  constructor() {}

  static getUrl(url:string): string{
    return this.apiUrl + 'api/' + url;
  }

  static getUrlNotApi(url:string): string{
    return this.apiUrl + url;
  }

  static getCustomUrl(url:string): string{
    return url;
  }

}